import "core-js/modules/es.function.name.js";
import jQuery from "jquery";
var Dropzone = require("dropzone");
Dropzone.autoDiscover = false;
if (jQuery(".classified_logo").length) {
  var myDropzone = new Dropzone("div.classified_logo", {
    url: i18n.classified.urls.creation,
    maxFiles: 1,
    uploadMultiple: false,
    acceptedFiles: "image/jpg,image/png,image/jpeg",
    maxFilesize: 2,
    paramName: "logo",
    addRemoveLinks: true,
    init: function init() {
      var thisDropzone = this;
      jQuery.get(i18n.classified.urls.creation + "?get_logo", function (data) {
        jQuery.each(data, function (key, value) {
          if (!value) return;
          var mockFile = {
            name: value.name,
            size: value.size,
            attachment_id: value.attachment_id
          };
          thisDropzone.options.addedfile.call(thisDropzone, mockFile);
          thisDropzone.options.thumbnail.call(thisDropzone, mockFile, value.thumbnail);
          checkDropZoneMaxFiles();
        });
      });
    }
  });
  myDropzone.on("success", function (file) {
    checkDropZoneMaxFiles();
  });
  myDropzone.on("removedfile", function (file) {
    jQuery.get(i18n.classified.urls.creation + "?remove_logo=" + file.attachment_id, function (data) {
      // classifiedUpdatePreview();
      checkDropZoneMaxFiles();
    });
  });
  var checkDropZoneMaxFiles = function checkDropZoneMaxFiles() {
    if (jQuery(".dz-success").length >= 1) {
      jQuery('.dz-hidden-input').attr('disabled', 'disabled');
    } else {
      jQuery('.dz-hidden-input').removeAttr('disabled');
    }
  };
}